"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewItemLayer = void 0;
var GameVars_1 = require("../../../GameVars");
var GameConstants_1 = require("../../../GameConstants");
var Utils_1 = require("../../../utils/Utils");
var BoardManager_1 = require("../BoardManager");
var AudioManager_1 = require("../../../AudioManager");
var NewItemLayer = /** @class */ (function (_super) {
    __extends(NewItemLayer, _super);
    function NewItemLayer(scene) {
        var _this = _super.call(this, scene) || this;
        _this.leavingLayer = false;
        var darkBackground = new Phaser.GameObjects.Graphics(_this.scene);
        darkBackground.fillStyle(0x321B38);
        darkBackground.fillRect(0, 0, GameVars_1.GameVars.gameWidth, GameVars_1.GameVars.gameHeight);
        darkBackground.alpha = .6;
        _this.add(darkBackground);
        var scaledItemsContainer = new Phaser.GameObjects.Container(_this.scene, GameVars_1.GameVars.gameWidth / 2, GameVars_1.GameVars.gameHeight / 2);
        scaledItemsContainer.scaleY = GameVars_1.GameVars.scaleY;
        _this.add(scaledItemsContainer);
        var glowImage = new Phaser.GameObjects.Image(_this.scene, 0, 0, "texture_atlas_1", "radial_new_cake_mistery_box");
        glowImage.setScale(1.25);
        glowImage.blendMode = Phaser.BlendModes.SCREEN;
        scaledItemsContainer.add(glowImage);
        _this.scene.tweens.add({
            targets: glowImage,
            scaleX: 1.5,
            scaleY: 1.5,
            ease: Phaser.Math.Easing.Cubic.InOut,
            duration: 750,
            yoyo: true,
            repeat: -1
        });
        _this.scene.tweens.add({
            targets: glowImage,
            angle: 360,
            ease: Phaser.Math.Easing.Linear,
            duration: 4250,
            repeat: -1
        });
        var titleBackground = new Phaser.GameObjects.Image(_this.scene, 0, -260, "texture_atlas_0", "title_cookie_base");
        scaledItemsContainer.add(titleBackground);
        var title = new Phaser.GameObjects.Image(_this.scene, 0, titleBackground.y, "texture_atlas_1", "title_new_recipe");
        scaledItemsContainer.add(title);
        var textureAtlas;
        var newItemTextureName;
        var oldItemTextureName;
        if (GameVars_1.GameVars.gameData.mode === GameConstants_1.GameConstants.GAME_MODE_1) {
            textureAtlas = "texture_atlas_2";
            newItemTextureName = "cake_" + GameVars_1.GameVars.modeGameData.iMaxItemUncovered;
            oldItemTextureName = "cake_" + (GameVars_1.GameVars.modeGameData.iMaxItemUncovered - 1);
        }
        else {
            textureAtlas = "texture_atlas_3";
            newItemTextureName = "biscuits_" + GameVars_1.GameVars.modeGameData.iMaxItemUncovered;
            oldItemTextureName = "biscuits_" + (GameVars_1.GameVars.modeGameData.iMaxItemUncovered - 1);
        }
        var itemBase = new Phaser.GameObjects.Image(_this.scene, 0, 0, "texture_atlas_1", "new_recipe_base");
        scaledItemsContainer.add(itemBase);
        var newItemImage = new Phaser.GameObjects.Image(_this.scene, 0, 0, textureAtlas, newItemTextureName);
        newItemImage.setOrigin(.5, .55);
        var size = Math.sqrt(newItemImage.width * newItemImage.height);
        var maxSize;
        if (size < 200) {
            maxSize = 180;
        }
        else if (size < 250) {
            maxSize = 205;
        }
        else if (size < 300) {
            maxSize = 250;
        }
        else {
            maxSize = 265;
        }
        if (newItemImage.height > newItemImage.width) {
            newItemImage.setScale(maxSize / newItemImage.height);
        }
        else {
            newItemImage.setScale(maxSize / newItemImage.width);
        }
        scaledItemsContainer.add(newItemImage);
        var oldItemImage = new Phaser.GameObjects.Image(_this.scene, 0, 0, textureAtlas, oldItemTextureName);
        oldItemImage.setOrigin(.5, .55);
        size = Math.sqrt(oldItemImage.width * oldItemImage.height);
        if (size < 200) {
            maxSize = 180;
        }
        else if (size < 250) {
            maxSize = 205;
        }
        else if (size < 300) {
            maxSize = 250;
        }
        else {
            maxSize = 265;
        }
        if (oldItemImage.height > oldItemImage.width) {
            oldItemImage.setScale(maxSize / oldItemImage.height);
        }
        else {
            oldItemImage.setScale(maxSize / oldItemImage.width);
        }
        scaledItemsContainer.add(oldItemImage);
        _this.scene.tweens.add({
            targets: oldItemImage,
            alpha: 0,
            scaleX: .75,
            scaleY: .75,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 450,
            delay: 750
        });
        newItemImage.alpha = 0;
        newItemImage.setScale(.75);
        var itemName = new Phaser.GameObjects.Text(_this.scene, 0, 140, GameVars_1.GameVars.cakesNames[GameVars_1.GameVars.gameData.mode === GameConstants_1.GameConstants.GAME_MODE_1 ? "MODE_1" : "MODE_2"][GameVars_1.GameVars.modeGameData.iMaxItemUncovered - 1].toUpperCase(), { fontFamily: "Baloo", fontSize: "40px", color: "#FFFFFF", align: "center" });
        itemName.setOrigin(.5);
        itemName.setScale(.75);
        itemName.alpha = 0;
        itemName.setStroke("#703E25", 8);
        scaledItemsContainer.add(itemName);
        _this.scene.tweens.add({
            targets: [newItemImage, itemName],
            alpha: 1,
            scaleX: 1,
            scaleY: 1,
            ease: Phaser.Math.Easing.Cubic.InOut,
            duration: 800,
            delay: 800,
            onStart: function () {
                this.scene.shockwavePlugin.add(GameVars_1.GameVars.gameWidth / 2, GameVars_1.GameVars.gameHeight / 2, {
                    amplitude: 40,
                    wavelength: 275,
                    brightness: 1,
                    speed: 950,
                    radius: -1 // max radius of the shockwave, -1 is unlimited
                });
            },
            onStartScope: _this,
            onComplete: function () {
                this.scene.shockwavePlugin.remove();
            },
            onCompleteScope: _this
        });
        var nextButton = new Utils_1.Button(_this.scene, 0, 285, "texture_atlas_1", "btn_ok_off", "btn_ok_on");
        nextButton.onDown(_this.onClickNext, _this);
        scaledItemsContainer.add(nextButton);
        nextButton.alpha = 0;
        _this.scene.tweens.add({
            targets: nextButton,
            y: 255,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 500,
            delay: 1750
        });
        _this.alpha = 0;
        _this.scene.tweens.add({
            targets: _this,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 350
        });
        AudioManager_1.AudioManager.playSound("new_recipe_appears");
        return _this;
    }
    NewItemLayer.prototype.onClickNext = function () {
        BoardManager_1.BoardManager.removeNewItemLayer();
        if (this.leavingLayer) {
            return;
        }
        this.leavingLayer = true;
        var w = window;
        var now = new Date().getTime();
        if (GameVars_1.GameVars.gameData.tutorialPhase === 0 && now - GameVars_1.GameVars.timeAdShown > 120000 && typeof w.gdsdk !== "undefined" && w.gdsdk.showAd !== "undefined") {
            w.gdsdk.showAd();
        }
        else {
            BoardManager_1.BoardManager.removeNewItemLayer();
        }
        AudioManager_1.AudioManager.playSound("click_button");
    };
    return NewItemLayer;
}(Phaser.GameObjects.Container));
exports.NewItemLayer = NewItemLayer;
